(function () {
  'use strict';

  if (window.PGHomePolishV33R3) return;
  window.PGHomePolishV33R3 = true;

  function restoreCue() {
    var cue = document.querySelector('.pg-swipe-cue--likeness');
    if (!cue) return;
    cue.classList.remove('is-dismissed');
    cue.removeAttribute('aria-hidden');
  }

  function init() {
    restoreCue();

    var root = document.querySelector('[data-pg-likeness-slider]');
    var rail = root && root.querySelector('[data-pg-likeness-rail]');
    if (!root || !rail || root.dataset.pgV33R3Ready === 'true') return;

    root.dataset.pgV33R3Ready = 'true';
    ['pointerdown', 'touchstart', 'wheel', 'scroll'].forEach(function (eventName) {
      rail.addEventListener(eventName, function () {
        window.requestAnimationFrame(restoreCue);
        window.setTimeout(restoreCue, 420);
      }, { passive: true });
    });
  }

  function boot() {
    init();
    [120, 400, 900, 1800].forEach(function (delay) {
      window.setTimeout(init, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 0);
  });
})();
